// hook
import { useMutation } from "@tanstack/react-query";
// component
import Loading from "../../../../components/loading/loading";
// cookie
// @ts-ignore
import Cookies from 'js-cookie';
// layouts
import { UserCharge, UserChargeTest } from "../../../../services/charge/userCharge";
import { useEffect, useState } from "react";
import { splitNumber } from "../../../../features/splitNumber/splitNumber";

const HomePaymentUser = () => {
    let [price, setPrice] = useState();
    let [price2, setPriceTwo] = useState();
    let [token, setToken] = useState();
    let [isReferal, setReferal] = useState();
    const mutation = useMutation({
        mutationFn: UserCharge,
        onSuccess: data => {
            setToken(data.token)
            setPrice(data.price)
            setPriceTwo(data.payblePrice)
            setReferal(data.isReferral);
            if (data.isReferral) {
                Cookies.set('payment_amount', data.payblePrice)
            }
            else {
                Cookies.set('payment_amount', data.price)
            }
        },
        onError: (error) => {
            console.log(error)
        },
    });

    useEffect(() => {
        document.getElementById('site-main')?.classList.remove('main-content')
        document.getElementById('site-main')?.classList.add('bg-payment-new')
        document.getElementById('site-main')?.classList.add('bg-payment-new-home')
        document.getElementById('site-main')?.classList.add('bg-white')
        mutation.mutate(Cookies.get('mobileNumber'))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <article className={'payment overflow-x-hidden'}>
                <div className="row justify-content-center h-100">
                    <header className={'container text-center'}>
                        <div className="top-bar" style={{ paddingBottom: '15px' }}>
                            <div className="d-flex justify-content-center">
                                <img alt="logo" src={require('./../../../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp')} className="img-fluid" />
                            </div>
                            <p className="text-white text-center mb-5 fw-bold">
                                سامانه ملی امن, سریع و آسان تراکنش ایران
                            </p>
                        </div>
                    </header>
                    <div className="col-md-6 col-lg-4">
                        {mutation.isPending ? (
                            <Loading />
                        ) : (
                            <>
                                <section className={'profile container'}>
                                    <div className={'profile-items d-flex justify-content-center text-center'}>
                                        <img
                                            alt='profile'
                                            className='profile-img-valid'
                                            src={require('./../../../../assets/media/images/payment/Profile_Vr_01 1.png')} />
                                    </div>
                                    <p className={'fw-bold text-center mt-3 mb-1'}>
                                        {localStorage.getItem('name')}
                                    </p>
                                    <p className={'text-muted text-center mb-2'}>
                                        {Cookies.get('mobileNumber')}
                                    </p>
                                </section>
                                <section id={'endPoint'} className={'container text-center mb-3'}>
                                    <span className="badge bg-success-site font-medium mt-2 px-4 py-2 fw-bold" style={{ fontSize: '18px' }}>
                                        ثبت نام
                                    </span>
                                </section>
                                <div className='container-fluid'>
                                    <section className={'alert d-flex bg-success-site align-items-center justify-content-between py-3 my-2 mt-3'}>
                                        <p className={'font-small fw-bold text-white fw-bold mb-0'}>
                                            هزینه سرویس ایران تراکنش بدون کد دعوت
                                            <div className="d-md-none d-block"></div>
                                            ( با احتساب 10 % مالیات)
                                        </p>
                                        <p className={'price font-small fw-bold text-white mb-0'}>
                                            <span className={'price-amount ms-1'}>
                                                {splitNumber(price)}
                                            </span>
                                            تومان
                                        </p>
                                    </section>
                                </div>
                                {isReferal ? (
                                    <>
                                        <div className='container-fluid'>
                                            <section className={'alert d-flex bg-success-site align-items-center justify-content-between py-3 my-2 mt-3'}>
                                                <p className={'font-small fw-bold text-white fw-bold mb-0'}>
                                                    هزینه سرویس ایران تراکنش با کد دعوت شما
                                                    <div className="d-md-none d-block"></div>
                                                    ( با احتساب 10 % مالیات)
                                                </p>
                                                <p className={'price font-small fw-bold text-white mb-0'}>
                                                    <span className={'price-amount ms-1'}>
                                                        {splitNumber(price2)}
                                                    </span>
                                                    تومان
                                                </p>
                                            </section>
                                        </div>
                                    </>
                                ) : null}
                                <section className={'action container w-100 my-1 mt-2'}>
                                    <div className={'d-flex w-100 justify-content-center w-100 mt-4'}>
                                        <div className="w-100">
                                            <button
                                                onClick={() => window.open(`https://sep.shaparak.ir/Onlinepg/sendtoken?token=${token}`, '_self')}
                                                className={'btn btn-site w-100 px-5 mb-3 w-100 text-white'}>
                                                <p className={'card-text'}>
                                                    تایید و پرداخت
                                                </p>
                                            </button>
                                            <div className="d-flex justify-content-center">
                                                <span style={{ borderBottom: '1px solid #FFB72B' }} className={'font-small rounded-3 mb-0 text-center'}>
                                                    بدون نیاز به نصب اپلیکیشن
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </>
                        )}
                    </div>
                </div>
            </article >
        </>
    )
}

export default HomePaymentUser;